import React, { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import AnimationScreen from '../components/AnimationScreen';
import ProgressBar from '../components/ProgressBar';
import NavigationBar from '../components/NavigationBar';
import ResourceList from '../components/ResourceList';
import AdditionalHelp from '../components/AdditionalHelp';
import { GHLink, PageData } from '../types/types';
import { getBearingDetails } from '../../components/bearing-search/api/api';

const BearingResults: React.FC = () => {
	const { title, progress, prev, content, partNumber } =
		useLoaderData() as PageData;
	const [ partLinks, setPartLinks ] = useState<GHLink[]>( [] );

	useEffect( () => {
		getBearingDetails( partNumber || '' ).then( ( urls ) => {
			const links: GHLink[] = [];

			if ( urls.details_url ) {
				links.push( {
					id: 'bearing_info_specs',
					label: 'Product Specifications',
					url: urls.details_url,
				} );
			}

			if ( urls.cad_url ) {
				links.push( {
					id: 'bearing_info_cad',
					label: 'CAD Drawings',
					url: urls.cad_url,
				} );
			}

			setPartLinks( links );
		} );
	}, [] );

	return (
		<AnimationScreen>
			<ProgressBar progress={progress} />
			<h3>
				{title}:<br />
				{partNumber}
			</h3>
			<div className="c-guided-help__support">
				{partLinks.length === 0 && (
					<div className="c-guided-help__resources">
						<div className="a-block-cta-skeleton">
							<div className="a-block-cta-skeleton__text"></div>
							<div className="a-block-cta-skeleton__icon"></div>
						</div>
					</div>
				)}

				{partLinks.length > 0 && <ResourceList resources={partLinks} />}

				{content.additionalLinks && (
					<AdditionalHelp links={content.additionalLinks} />
				)}
			</div>
			<NavigationBar prev={prev} last={true} />
		</AnimationScreen>
	);
};

export default BearingResults;
